<p-toast />
<div class="card">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="start">
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (onClick)="backToSupport()" />
        </ng-template>
        <ng-template pTemplate="center">
            <span class="font-semibold text-xl">Order {{ orderNumber }}</span>
        </ng-template>
        <ng-template pTemplate="end">
            <p-button
                label="View invoice"
                icon="pi pi-file-pdf"
                [loading]="invoiceLoading"
                [disabled]="!header"
                (onClick)="viewInvoice()"
            />
        </ng-template>
    </p-toolbar>

    <div *ngIf="loading" class="p-4 text-center">Loading order...</div>

    <ng-container *ngIf="!loading && header">
        <div class="summary-grid mb-4 p-3 border-round">
            <div><strong>Status:</strong> {{ header.orderMovingStatus || header.status }}</div>
            <div><strong>Customer:</strong> {{ header.customerName }} ({{ header.customerId }})</div>
            <div><strong>Requested:</strong> {{ header.requestedDate | date: 'mediumDate' }}</div>
            <div><strong>Net:</strong> {{ header.netAmount }}</div>
            <div><strong>Gross:</strong> {{ header.grossValue }}</div>
            <div><strong>Invoice #:</strong> {{ header.invoiceNumber || '—' }}</div>
            <div *ngIf="header.customerAddress"><strong>Address:</strong> {{ header.customerAddress }}</div>
            <div *ngIf="header.totalArticles != null"><strong>Articles:</strong> {{ header.totalArticles }}</div>
            <div *ngIf="header.totalWeight != null"><strong>Weight:</strong> {{ header.totalWeight }}</div>
            <div *ngIf="header.outstanding"><strong>Outstanding:</strong> {{ header.outstanding }}</div>
            <div><strong>Co / Div:</strong> {{ header.companyId }} / {{ header.divisionId }}</div>
        </div>

        <p-table [value]="lines" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Line</th>
                    <th>Item #</th>
                    <th>Name</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Line amount</th>
                    <th>Status</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-line>
                <tr>
                    <td>{{ line.lineNo }}</td>
                    <td>{{ line.itemNo }}</td>
                    <td>{{ line.itemName }}</td>
                    <td>{{ line.qty }}</td>
                    <td>{{ line.rate ?? '—' }}</td>
                    <td>{{ line.lineAmount }}</td>
                    <td>{{ line.status }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">No order lines.</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</div>
